export const onlyDigits = (value = '') => String(value).replace(/\D/g, '');

export const formatCpf = (value = '') => {
  const digits = onlyDigits(value).slice(0, 11);

  if (!digits) {
    return '';
  }

  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2');
};

export const formatCnpj = (value = '') => {
  const digits = onlyDigits(value).slice(0, 14);

  if (!digits) {
    return '';
  }

  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

export const normalizeCpfCnpj = (value = '') => onlyDigits(value).slice(0, 14);

export const formatCpfCnpj = (value = '') => {
  const digits = normalizeCpfCnpj(value);

  if (!digits) {
    return '';
  }

  return digits.length <= 11 ? formatCpf(digits) : formatCnpj(digits);
};

export const normalizeCep = (value = '') => onlyDigits(value).slice(0, 8);

export const formatCep = (value = '') => {
  const digits = normalizeCep(value);

  if (!digits) {
    return '';
  }

  return digits.replace(/^(\d{5})(\d)/, '$1-$2');
};

export const normalizePhone = (value = '') => onlyDigits(value).slice(0, 11);

export const formatPhone = (value = '') => {
  const digits = normalizePhone(value);

  if (!digits) {
    return '';
  }

  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2');
};

export const normalizeUf = (value = '') => String(value)
  .replace(/[^a-zA-Z]/g, '')
  .toUpperCase()
  .slice(0, 2);

export const formatUf = (value = '') => normalizeUf(value);
